import { Autocomplete, Box, Chip, Dialog, DialogContent, DialogTitle, FormControl, FormHelperText, IconButton, MenuItem, Stack, styled, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, ToggleButton, ToggleButtonGroup, Typography, useMediaQuery, Backdrop, CircularProgress } from "@mui/material";
import axios from "axios";
import { debounce } from "lodash";
import { useNavigate, useLocation } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import { MsgContext } from "../../App";
import "../css/CommonDesign.css";
import icon_hatena from "../images/hatena_gray.svg";
import img_ogp_images from "../images/ogp_images.png";
//import { AuthInfoContext } from "./AuthContextProvider.tsx";
import { API, PAGE_SIZE, CSV_PLANTQUAR, MSG } from "./constantsFront";

import { Close } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";

import $ from "jquery";
import { useDispatch } from "react-redux";
import { FoodAdditiveSearchResultTable } from "./FoodAdditiveSearchResultTable";
import MenuMenu from "./MenuMenu";
// import { setSearchCondition } from "../redux/slice/searchConditionSlice";
import { DataGrid, jaJP } from "@mui/x-data-grid";
import { constantsMsg, constantsCategory, constantsElement, constantsMet } from "./constantsEU";
import Helmet from 'react-helmet';
import { fetchIpAddress } from "./D001Common";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};


const D0131FoodAdditive = () => {

  const dispatch = useDispatch();

  // 輸出判定チェックで入力された値は初期表示に利用することが不可能なので受け取らない
  // const location = useLocation()
  // let iniCountryName = constantsMsg.STR_PLZ_SELECT;
  // let iniProductName = constantsMsg.STR_PLZ_SELECT;
  // let iniPesticide = [];
  // if (location.state != null) {
  //   let eachData = location.state.eachData;
  //   iniProductName = eachData.product_name;
  //   iniCountryName = eachData.country_name;
  //   if (eachData.pesticide) {
  //     iniPesticide = [{ pesticide: eachData.pesticide }];
  //   }
  // }

  // よく見られる品目ボタンリスト
  const [seenAdditiveList, setSeenAdditiveList] = useState([]);
  const [hideAdditiveList, setHideAdditiveList] = useState([]);
  // よく見られる輸出先国ボタンリスト
  const [seenCategoryList, setSeenCategoryList] = useState([]);
  const [hideCategoryList, setHideCategoryList] = useState([]);

  // hideリストオープン
  const [isAdditiveOpen, setIsAdditiveOpen] = useState(false);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);

  // 前回のキーワード
  const [beforeAdditive, setBeforeAdditive] = useState("");
  // 表示候補(本来はreduxのuseSelectorなんかでデータを管理する)
  const [additiveOptions, setAdditiveOptions] = useState([]);
  // 選択されている内容
  const [autocompleteAdditive, setAutocompleteAdditive] = useState([]);

  const [errorAdditive, setErrorAdditive] = useState(""); // 農薬名エラー

  // 添加物カテゴリーリスト
  const [additiveCategoryList, setAdditiveCategoryList] = useState("");
  // 添加物リスト
  const [additiveColorList, setAdditiveColorList] = useState("");
  const [additiveSweetList, setAdditiveSweetList] = useState("");
  const [additiveOtherList, setAdditiveOtherList] = useState("");
  // 和名頭文字リスト
  const [jaIniList, setJaIniList] = useState("");

  // DBデータ
  const [additiveList, setAdditiveList] = useState(""); // 添加物
  const [foodCategoryList, setFoodCategoryList] = useState(""); // 食品カテゴリー
  const [footnoteList, setFootnoteList] = useState(""); // 脚注
  const [foodAdditiveDBList, setfoodAdditiveDBList] = useState(""); // 食品添加物DB
  const [combinationList, setCombinationList] = useState(""); // 組み合わせ

  // ダイアログ添加物タブ名前
  const [colorName, setColorName] = useState(""); // 着色料
  const [sweetName, setSweetName] = useState(""); // 甘味料
  const [otherName, setOtherName] = useState(""); // その他

  // ダイアログイニシャルタブ
  const [initialsTab, setInitialsTab] = useState(""); // 着色料

  //ダイアログコンテキスト
  const [additiveColorDialogContent, setAdditiveColorDialogContent] = useState(""); // 着色料
  const [additiveSweetDialogContent, setAdditiveSweetDialogContent] = useState(""); // 甘味料
  const [additiveOtherDialogContent, setAdditiveOtherDialogContent] = useState(""); // その他
  const [isColorDialog, setIsColorDialog] = useState(false);
  const [isSweetDialog, setIsSweetDialog] = useState(false);
  const [isOtherDialog, setIsOtherDialog] = useState(false);

  const [searchConditionValue, setSearchConditionValue] = React.useState({ Enumber: "", foodCategoryNumber: "" });

  // ダイアログ関連
  const [colorDialogValue, setColorDialogValue] = React.useState(0);
  const [sweetDialogValue, setSweetDialogValue] = React.useState(0);
  const [otherDialogValue, setOtherDialogValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [dialogCategory, setDialogCategory] = useState("1"); // ダイアログ内の添加物カテゴリー番号

  const [primaryCategoryName, setPrimaryCategoryName] = useState(constantsCategory.STR_PRIMARY); // 大食品カテゴリー名
  const [primaryCategoryList, setPrimaryCategoryList] = useState([{ content: constantsCategory.STR_PRIMARY }]); // 大食品カテゴリーリスト
  const [secondaryCategoryName, setSecondaryCategoryName] = useState(constantsCategory.STR_SECONDARY); // 中食品カテゴリー名
  const [secondaryCategoryList, setSecondaryCategoryList] = useState([{ content: constantsCategory.STR_SECONDARY }]); // 中食品カテゴリーリスト
  const [tertiaryCategoryName, setTertiaryCategoryName] = useState(constantsCategory.STR_TERTIARY); // 小食品カテゴリー名
  const [tertiaryCategoryList, setTertiaryCategoryList] = useState([{ content: constantsCategory.STR_TERTIARY }]); // 小食品カテゴリーリスト
  const [quaternaryCategoryName, setQuaternaryCategoryName] = useState(constantsCategory.STR_QUATERNARY); // 細食品カテゴリー名
  const [quaternaryCategoryList, setQuaternaryCategoryList] = useState([{ content: constantsCategory.STR_QUATERNARY }]); // 細食品カテゴリーリスト

  // 説明ダイアログ
  const [additiveOpen, setAdditiveOpen] = React.useState(false);
  const [categoryOpen, setCategoryOpen] = React.useState(false);

  // 脚注ダイアログ
  const [footnoteOpen, setFootnoteOpen] = React.useState(false);

  // E番号一覧ダイアログ
  const [ENumOpen, setENumOpen] = React.useState(false);
  const [rows, setRows] = useState([]); // 表示データ
  const [pageSize, setPageSize] = useState(10);// EU添加物リストページサイズ

  // エラーメッセージ
  const { msg, setMsg } = useContext(MsgContext);

  // Loading
  const [isLoading, setIsLoading] = useState(false);

  // ダイアログ用
  const selectValue = {
    autocompleteAdditive,
    setAutocompleteAdditive
  };

  // 画面表示用添加物検索条件
  const [selectedAdditiveName, setSelectedAdditiveName] = useState("");
  // 画面表示用食品カテゴリー
  const [selectedFoodCategoryName, setFoodCategoryName] = useState("");
  // 画面表示用添加物情報リスト
  const [resultFoodAdditive, setResultFoodAdditive] = useState([{
    id: 0
    , enumber: null
    , foodCategory: null
    , foodCategoryNumber: null
    , INSnumber: null
    , additiveNameEN: null
    , additiveNameJP: null
    , nationalRegulations: null
    , maximumValue: null
    , footnote: null
    , groupFootnote: null
    , constraintException: null
  }]);

  // テーブル管理用
  const [isSearchFailed, setSearchFailed] = useState(false);
  const [isHiddenTable, setHiddenTable] = useState(true);
  const [tablePage, setTablePage] = useState(1);
  const handleChange = (event, index) => {
    setTablePage(index);
  }

  // POSTデータ
  let body = { authKey: API.API_KEY };

  useEffect(() => {
    // 添加物カテゴリーリスト
    axios.post("/m_eu_additive_category/select", body).then(res => {
      setAdditiveCategoryList(res.data.dataList);
      const additiveCategoryList = res.data.dataList;
      setColorName(additiveCategoryList[0].additive_category);
      setSweetName(additiveCategoryList[1].additive_category);
      setOtherName(additiveCategoryList[2].additive_category);
    }).catch((err) => {
      if (err.request.status == 500) {
        return setMsg(constantsMsg.STR_ERROR);
      }
    });

    // 添加物リスト
    axios.post("/m_eu_additive_list/select", body).then(res => {
      setAdditiveList(res.data.dataList);
      // const additiveList = res.data.dataList;
    }).catch((err) => {
      if (err.request.status == 500) {
        return setMsg(constantsMsg.STR_ERROR);
      }
    });

    // プルダウン-食品カテゴリー大項目
    body.number = 1;
    axios.post("/m_eu_food_category_list/select", body).then(res => {
      let primaryCategoryList = [{ content: constantsCategory.STR_PRIMARY, food_category_number: "0.0" }];  // keyが重複しないように仮のカテゴリー番号を設定
      primaryCategoryList = primaryCategoryList.concat(res.data.dataList);
      setPrimaryCategoryList(primaryCategoryList);
    }).catch((err) => {
      if (err.request.status == 500) {
        return setMsg(constantsMsg.STR_ERROR);
      }
    });

    // E番号一覧取得
    body = { authKey: API.API_KEY };
    body.order = "e_number";
    axios.post("/m_eu_additive_list/select", body)
      .then(res => {
        setRows(res.data.dataList);
      }).catch(error => {
        console.log('error:', error);
        setMsg(MSG.EXCEPTION);
      });

    displayHistory();
  }, [])

  // 履歴用
  function displayHistory() {
    // 添加物履歴
    body.pageName = "EU食品添加物";
    body.type = 3;
    axios.post("/t_search_his/select_foodadditive", body).then(res => {
      let additiveHisList = res.data.dataList;

      // 添加物履歴ボタン作成
      let seenAdditiveList = [];
      let hideAdditiveList = [];
      for (let i in additiveHisList) {
        if (i == 12) {
          // seenAdditiveList.push(<p className="exceeded">・・・</p>);
          break;
        } else {
          let bg = "bg3";
          if (i < 2) {
            bg = "bg1";
          } else if (i < 4) {
            bg = "bg2";
          }
          let additiveHis = { additive_name_jp: additiveHisList[i].name };
          let additivename = cutName(additiveHisList[i].name);
          if (i < 6) {
            seenAdditiveList.push(
              <li
                class={bg}
                style={{ cursor: "pointer" }}
                onClick={(function (value) {
                  return async function () {
                    setAutocompleteAdditive([additiveHis]);
                  }
                })(additiveHisList[i].name)}
              >
                <a>{additivename}</a>
              </li>);
          } else {
            hideAdditiveList.push(
              <li
                class={bg}
                style={{ cursor: "pointer" }}
                onClick={(function (value) {
                  return async function () {
                    setAutocompleteAdditive([additiveHis]);
                  }
                })(additiveHisList[i].name)}
              >
                <a>{additivename}</a>
              </li>);
          }
        }
      }
      setSeenAdditiveList(seenAdditiveList);
      setHideAdditiveList(hideAdditiveList);
    }).catch((err) => {
      return setMsg(constantsMsg.STR_ERROR);
    });

    // 食品カテゴリー履歴
    body.type = 4;
    axios.post("/t_search_his/select_foodadditive", body).then(res => {
      let categoryHisList = res.data.dataList;

      // 食品カテゴリー履歴ボタン作成
      let seenCategoryList = [];
      let hideCategoryList = [];
      for (let i in categoryHisList) {
        if (i == 12) {
          // seenCategoryList.push(<p className="exceeded">・・・</p>);
          break;
        } else {
          let bg = "bg3";
          if (i < 2) {
            bg = "bg1";
          } else if (i < 4) {
            bg = "bg2";
          }
          // let categoryHis = { country_code: categoryHisList[i].code, country_name: categoryHisList[i].name };
          // let categoryNumber = categoryHisList[i].code;
          let categoryname = cutName(categoryHisList[i].name);
          if (i < 6) {
            seenCategoryList.push(
              <li
                class={bg}
                style={{ cursor: "pointer" }}
                onClick={() => CategorySet(categoryHisList[i].code)}
              >
                <a>{categoryname}</a>
              </li>);
          } else {
            hideCategoryList.push(
              <li
                class={bg}
                style={{ cursor: "pointer" }}
                onClick={() => CategorySet(categoryHisList[i].code)}
              >
                <a>{categoryname}</a>
              </li>);
          }
        }
      }
      setSeenCategoryList(seenCategoryList);
      setHideCategoryList(hideCategoryList);
    }).catch((err) => {
      return setMsg(constantsMsg.STR_ERROR);
    });
  }

  // 履歴から食品カテゴリーをセット
  function CategorySet(number) {
    let splNumber = number.split('.');
    let pNumber = parseInt(splNumber[0], 10) + 1;
    let sNumber = "";
    let tNumber = "";
    let qNumber = "";
    if (splNumber.length > 1) {
      sNumber = splNumber[1];
    }
    if (splNumber.length > 2) {
      tNumber = splNumber[2];
    }
    if (splNumber.length > 3) {
      qNumber = splNumber[3];
    }

    axios.post("/m_eu_food_category_list/select_all", body).then(res => {
      let foodCategoryList = res.data.dataList;
      let primaryCategoryList = [{ content: constantsCategory.STR_PRIMARY, food_category_number: "0.0" }];
      let secondaryCategoryList = [{ content: constantsCategory.STR_SECONDARY, food_category_number: "0.0" }];
      let tertiaryCategoryList = [{ content: constantsCategory.STR_TERTIARY, food_category_number: "0.0" }];
      let quaternaryCategoryList = [{ content: constantsCategory.STR_QUATERNARY, food_category_number: "0.0" }];

      for (var i = 0; i < foodCategoryList.length; i++) {
        if (foodCategoryList[i].hierarchy_number == 1) {
          primaryCategoryList = primaryCategoryList.concat(foodCategoryList[i]);
        } else if (foodCategoryList[i].hierarchy_number == 2 && foodCategoryList[i].primary_category == splNumber[0]) {
          secondaryCategoryList = secondaryCategoryList.concat(foodCategoryList[i]);
        } else if (foodCategoryList[i].hierarchy_number == 3) {
          if (tNumber !== "" && foodCategoryList[i].primary_category == splNumber[0] && foodCategoryList[i].secondary_category == sNumber) {
            tertiaryCategoryList = tertiaryCategoryList.concat(foodCategoryList[i]);
          }
        } else if (foodCategoryList[i].hierarchy_number == 4) {
          if (qNumber !== "" && foodCategoryList[i].primary_category == splNumber[0] && foodCategoryList[i].secondary_category == sNumber && foodCategoryList[i].tertiary_category == tNumber) {
            quaternaryCategoryList = quaternaryCategoryList.concat(foodCategoryList[i]);
          }
        }
      }
      // console.log(primaryCategoryList);

      setPrimaryCategoryList(primaryCategoryList);
      setPrimaryCategoryName(primaryCategoryList[pNumber].content);
      setSecondaryCategoryList(secondaryCategoryList);
      if (sNumber !== "") {
        setSecondaryCategoryName(secondaryCategoryList[sNumber].content);
      } else {
        setSecondaryCategoryName(constantsCategory.STR_SECONDARY);
      }
      setTertiaryCategoryList(tertiaryCategoryList);
      if (tNumber !== "") {
        setTertiaryCategoryName(tertiaryCategoryList[tNumber].content);
      } else {
        setTertiaryCategoryName(constantsCategory.STR_TERTIARY);
      }
      setQuaternaryCategoryList(quaternaryCategoryList);
      if (qNumber !== "") {
        setQuaternaryCategoryName(quaternaryCategoryList[qNumber].content);
      } else {
        setQuaternaryCategoryName(constantsCategory.STR_QUATERNARY);
      }

    }).catch((err) => {
      if (err.request.status == 500) {
        return setMsg(constantsMsg.STR_ERROR);
      }
    });
  }


  // 名前が長いとき
  function cutName(name) {
    var length = 0;
    var seenName = name;
    for (var i = 0; i < name.length; i++) {
      var c = name.charCodeAt(i);
      if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
        length += 1;
      } else {
        length += 2;
      }
      if (length > 20) {
        seenName = name.substr(0, i);
        seenName = seenName + "…";
        break;
      }
    }
    return seenName;
  };

  // 食品カテゴリー大項目選択
  function primaryCategorySelect(value) {
    setPrimaryCategoryName(value);

    // プルダウン-食品カテゴリー中項目
    if (value != constantsCategory.STR_PRIMARY) {
      for (let i = 0; i < primaryCategoryList.length; i++) {
        if (primaryCategoryList[i].content == value) {
          body.primary = primaryCategoryList[i].primary_category;
        }
      }
      body.number = 2;
      axios.post("/m_eu_food_category_list/select", body).then(res => {
        let secondaryCategoryList = [{ content: constantsCategory.STR_SECONDARY, food_category_number: "0.0" }];
        secondaryCategoryList = secondaryCategoryList.concat(res.data.dataList);
        setSecondaryCategoryName(constantsCategory.STR_SECONDARY);
        setSecondaryCategoryList(secondaryCategoryList);
        setTertiaryCategoryName(constantsCategory.STR_TERTIARY);
        setTertiaryCategoryList([{ content: constantsCategory.STR_TERTIARY }]);
        setQuaternaryCategoryName(constantsCategory.STR_QUATERNARY);
        setQuaternaryCategoryList([{ content: constantsCategory.STR_QUATERNARY }]);
      }).catch((err) => {
        if (err.request.status == 500) {
          return setMsg(constantsMsg.STR_ERROR);
        }
      });
    } else {
      setSecondaryCategoryName(constantsCategory.STR_SECONDARY);
      setSecondaryCategoryList([{ content: constantsCategory.STR_SECONDARY }]);
      setTertiaryCategoryName(constantsCategory.STR_TERTIARY);
      setTertiaryCategoryList([{ content: constantsCategory.STR_TERTIARY }]);
      setQuaternaryCategoryName(constantsCategory.STR_QUATERNARY);
      setQuaternaryCategoryList([{ content: constantsCategory.STR_QUATERNARY }]);
    }
  }

  // 食品カテゴリー中項目選択
  function secondaryCategorySelect(value) {
    setSecondaryCategoryName(value);

    // プルダウン-食品カテゴリー小項目
    if (value != constantsCategory.STR_SECONDARY) {
      for (let i = 0; i < secondaryCategoryList.length; i++) {
        if (secondaryCategoryList[i].content == value) {
          body.primary = secondaryCategoryList[i].primary_category;
          body.secondary = secondaryCategoryList[i].secondary_category;
        }
      }
      body.number = 3;
      axios.post("/m_eu_food_category_list/select", body).then(res => {
        let tertiaryCategoryList = [{ content: constantsCategory.STR_TERTIARY, food_category_number: "0.0" }];
        tertiaryCategoryList = tertiaryCategoryList.concat(res.data.dataList);
        setTertiaryCategoryName(constantsCategory.STR_TERTIARY);
        setTertiaryCategoryList(tertiaryCategoryList);
        setQuaternaryCategoryName(constantsCategory.STR_QUATERNARY);
        setQuaternaryCategoryList([{ content: constantsCategory.STR_QUATERNARY }]);
      }).catch((err) => {
        if (err.request.status == 500) {
          return setMsg(constantsMsg.STR_ERROR);
        }
      });
    } else {
      setTertiaryCategoryName(constantsCategory.STR_TERTIARY);
      setTertiaryCategoryList([{ content: constantsCategory.STR_TERTIARY }]);
      setQuaternaryCategoryName(constantsCategory.STR_QUATERNARY);
      setQuaternaryCategoryList([{ content: constantsCategory.STR_QUATERNARY }]);
    }
  }

  // 食品カテゴリー小項目選択
  function tertiaryCategorySelect(value) {
    setTertiaryCategoryName(value);

    // プルダウン-食品カテゴリー細項目
    if (value != constantsCategory.STR_TERTIARY) {
      for (let i = 0; i < tertiaryCategoryList.length; i++) {
        if (tertiaryCategoryList[i].content == value) {
          body.primary = tertiaryCategoryList[i].primary_category;
          body.secondary = tertiaryCategoryList[i].secondary_category;
          body.tertiary = tertiaryCategoryList[i].tertiary_category;
        }
      }
      body.number = 4;
      axios.post("/m_eu_food_category_list/select", body).then(res => {
        let quaternaryCategoryList = [{ content: constantsCategory.STR_QUATERNARY, food_category_number: "0.0" }];
        quaternaryCategoryList = quaternaryCategoryList.concat(res.data.dataList);
        setQuaternaryCategoryName(constantsCategory.STR_QUATERNARY);
        setQuaternaryCategoryList(quaternaryCategoryList);
      }).catch((err) => {
        if (err.request.status == 500) {
          return setMsg(constantsMsg.STR_ERROR);
        }
      });
    } else {
      setQuaternaryCategoryName(constantsCategory.STR_QUATERNARY);
      setQuaternaryCategoryList([{ content: constantsCategory.STR_QUATERNARY }]);
    }
  }

  // 食品カテゴリー細項目選択
  function quaternaryCategorySelect(value) {
    setQuaternaryCategoryName(value);
  }

  // サジェスト用処理
  // 変更が止まった後、指定時間(ミリ秒)後処理を行う
  const term = 200;
  const additiveSearchHandler = debounce(
    (changeValue) => additiveSearchMethod(changeValue),
    term
  );

  const additiveSearchMethod = async (changeValue) => {
    try {
      setBeforeAdditive(changeValue);
      // 内容が同じ場合は処理しない
      if (changeValue.length > 0 && beforeAdditive !== changeValue) {
        body.additive = changeValue;

        const res = await axios.post("/m_eu_additive_list/select", body);
        setAdditiveOptions([...res.data.dataList]);
      } else {
        // オートコンプリートの内容初期化
        setAdditiveOptions([]);
      }
    } catch (err) {
      return setMsg(constantsMsg.STR_ERROR);
    }
  };

  // 添加物名選択
  const additiveChange = (event, selectedValue) => {
    // 選択されているオートコンプリート内容変更
    setAutocompleteAdditive([...selectedValue]);
    // オートコンプリートの内容初期化
    setAdditiveOptions([]);

    additiveSelect(selectedValue);
  };

  // 添加物エラーメッセージ
  function additiveSelect(value) {
    if (value.length >= 1) {
      setErrorAdditive("");
    } else {
      setErrorAdditive(constantsMsg.STR_PLZ_SELECT_ADDITIVE_NAME);
    }
  }

  // 添加物ラベル作成
  function label(option) {
    return option.additive_name_jp;
  }

  // ダイアログ内の添加物カテゴリー選択
  const categoryChange = (event, newcategory) => {
    if (newcategory) {
      setDialogCategory(newcategory);
      setColorDialogValue(0);
      setSweetDialogValue(0);
      setOtherDialogValue(0);

      if (newcategory == 1) {
        setIsColorDialog(true);
      } else {
        setIsColorDialog(false);
      }
      if (newcategory == 2) {
        setIsSweetDialog(true);
      } else {
        setIsSweetDialog(false);
      }
      if (newcategory == 3) {
        setIsOtherDialog(true);
      } else {
        setIsOtherDialog(false);
      }
      $("#dialog-content").scrollTop(0);
    }
  };

  function dialogData(additiveColorList, additiveSweetList, additiveOtherList, jaIniList) {
    try {
      let initialsTab = [];
      let additiveColorDialogContent = [];
      let additiveSweetDialogContent = [];
      let additiveOtherDialogContent = [];


      // 選択されている添加物名をまとめる
      let selectadditiveList = [];
      for (let i in autocompleteAdditive) {
        selectadditiveList.push(autocompleteAdditive[i].additive_name_jp);
      }

      // ダイアログ用
      let index = 0;

      // 着色料一覧の作成
      for (let i in jaIniList) {
        let jaInitials = jaIniList[i].ja_initials;
        initialsTab.push(<Tab label={jaInitials} {...a11yProps(i)} />);
        let categoryList = [];

        for (let j in additiveColorList) {
          let additive = additiveColorList[j].additive_name_jp;
          let eNumber = additiveColorList[j].e_number;
          let jaInitials2 = additiveColorList[j].ja_initials;
          if (jaInitials == jaInitials2) {
            let checkbox = <input type="checkbox" name="colorAdditive" value={j} id={eNumber} />;
            if (selectadditiveList.includes(additive) === true) {
              checkbox = <input type="checkbox" name="colorAdditive" value={j} id={eNumber} defaultChecked />;
            }
            categoryList.push(<li><label>{checkbox}{additive}</label></li>);
          }
        }

        let all = "all" + index;
        let br = <br />;
        if (index == 0) {
          br = "";
        }

        additiveColorDialogContent.push(<>{br}
          <li><label name={all} id={all}>{jaInitials}</label></li><hr />
          <ul>{categoryList}</ul>
        </>);
        index += 1;
      }

      // 甘味料一覧の作成
      for (let i in jaIniList) {
        let jaInitials = jaIniList[i].ja_initials;
        let categoryList = [];

        for (let j in additiveSweetList) {
          let additive = additiveSweetList[j].additive_name_jp;
          let eNumber = additiveSweetList[j].e_number;
          let jaInitials2 = additiveSweetList[j].ja_initials;
          if (jaInitials == jaInitials2) {
            let checkbox = <input type="checkbox" name="sweetAdditive" value={j} id={eNumber} />;
            if (selectadditiveList.includes(additive) === true) {
              checkbox = <input type="checkbox" name="sweetAdditive" value={j} id={eNumber} defaultChecked />;
            }
            categoryList.push(<li><label>{checkbox}{additive}</label></li>);
          }
        }

        let all = "all" + index;
        let br = <br />;
        if (index == 0) {
          br = "";
        }

        additiveSweetDialogContent.push(<>{br}
          <li><label name={all} id={all}>{jaInitials}</label></li><hr />
          <ul>{categoryList}</ul>
        </>);
        index += 1;
      }

      // その他一覧の作成
      for (let i in jaIniList) {
        let jaInitials = jaIniList[i].ja_initials;
        let categoryList = [];

        for (let j in additiveOtherList) {
          let additive = additiveOtherList[j].additive_name_jp;
          let eNumber = additiveOtherList[j].e_number;
          let jaInitials2 = additiveOtherList[j].ja_initials;
          if (jaInitials == jaInitials2) {
            let checkbox = <input type="checkbox" name="otherAdditive" value={j} id={eNumber} />;
            if (selectadditiveList.includes(additive) === true) {
              checkbox = <input type="checkbox" name="otherAdditive" value={j} id={eNumber} defaultChecked />;
            }
            categoryList.push(<li><label>{checkbox}{additive}</label></li>);
          }
        }

        let all = "all" + index;
        let br = <br />;
        if (index == 0) {
          br = "";
        }

        additiveOtherDialogContent.push(<>{br}
          <li><label name={all} id={all}>{jaInitials}</label></li><hr />
          <ul>{categoryList}</ul>
        </>);
        index += 1;
      }

      setDialogCategory("1");
      setIsColorDialog(true);
      setIsSweetDialog(false);
      setIsOtherDialog(false);
      setInitialsTab(initialsTab);
      setAdditiveColorDialogContent(additiveColorDialogContent);
      setAdditiveSweetDialogContent(additiveSweetDialogContent);
      setAdditiveOtherDialogContent(additiveOtherDialogContent);
    } catch (err) {
      return setMsg(constantsMsg.STR_ERROR);
    }
  }

  // 50音ダイアログ処理（選択した位置までスクロール）
  function colorDialogChange(event, newValue) {
    setColorDialogValue(newValue);
    //移動したい内容の位置を取得
    let top = $("#all" + newValue).offset().top;
    let all0Top = $("#all0").offset().top;
    //スクロールを移動する
    $("#dialog-content").scrollTop(top - all0Top + 10);
  };
  function sweetDialogChange(event, newValue) {
    setSweetDialogValue(newValue);
    //移動したい内容の位置を取得
    let top = $("#all" + (jaIniList.length + newValue)).offset().top;
    let all0Top = $("#all" + jaIniList.length).offset().top;
    //スクロールを移動する
    $("#dialog-content").scrollTop(top - all0Top + 30);
  };
  function otherDialogChange(event, newValue) {
    setOtherDialogValue(newValue);
    //移動したい内容の位置を取得
    let top = $("#all" + (jaIniList.length * 2 + newValue)).offset().top;
    let all0Top = $("#all" + jaIniList.length * 2).offset().top;
    //スクロールを移動する
    $("#dialog-content").scrollTop(top - all0Top + 30);
  };

  async function handleClickOpen() {
    try {
      // 着色添加物リスト
      body.item = 1;
      let res = await axios.post("/m_eu_additive_list/select", body);
      setAdditiveColorList(res.data.dataList);
      const additiveColorList = res.data.dataList;

      // 甘味添加物リスト
      body.item = 2;
      res = await axios.post("/m_eu_additive_list/select", body);
      setAdditiveSweetList(res.data.dataList);
      const additiveSweetList = res.data.dataList;

      // その他添加物リスト
      body.item = 3;
      res = await axios.post("/m_eu_additive_list/select", body);
      setAdditiveOtherList(res.data.dataList);
      const additiveOtherList = res.data.dataList;

      // 和名頭文字リスト
      res = await axios.post("/m_rac_ja_initials/select", body);
      setJaIniList(res.data.dataList);
      const jaIniList = res.data.dataList;

      dialogData(additiveColorList, additiveSweetList, additiveOtherList, jaIniList)
      setOpen(true);
    } catch (err) {
      return setMsg(constantsMsg.STR_ERROR);
    }
  };

  // キャンセルボタン
  function cancelButton() {
    setOpen(false);
    setColorDialogValue(0);
    setSweetDialogValue(0);
    setOtherDialogValue(0);
  };

  // 決定ボタン
  function decisionButton() {
    try {
      let additiveChecked = [];
      let colorAdditiveCheckList;
      let sweetAdditiveCheckList;
      let otherAdditiveCheckList;
      let additive;
      colorAdditiveCheckList = document.getElementsByName("colorAdditive");
      sweetAdditiveCheckList = document.getElementsByName("sweetAdditive");
      otherAdditiveCheckList = document.getElementsByName("otherAdditive");

      for (let i = 0; i < colorAdditiveCheckList.length; i++) {
        if (colorAdditiveCheckList[i].checked) {
          additive = additiveColorList[colorAdditiveCheckList[i].value].additive_name_jp;

          additiveChecked.push({
            additive_name_jp: additive
          });
        }
      }
      for (let i = 0; i < sweetAdditiveCheckList.length; i++) {
        if (sweetAdditiveCheckList[i].checked) {
          additive = additiveSweetList[sweetAdditiveCheckList[i].value].additive_name_jp;

          additiveChecked.push({
            additive_name_jp: additive
          });
        }
      }
      for (let i = 0; i < otherAdditiveCheckList.length; i++) {
        if (otherAdditiveCheckList[i].checked) {
          additive = additiveOtherList[otherAdditiveCheckList[i].value].additive_name_jp;

          additiveChecked.push({
            additive_name_jp: additive
          });
        }
      }

      setAutocompleteAdditive(additiveChecked);
      additiveSelect(additiveChecked);
      setOpen(false);
      setColorDialogValue(0);
      setSweetDialogValue(0);
      setOtherDialogValue(0);
    } catch (err) {
      return setMsg(constantsMsg.STR_ERROR);
    }
  };

  // 結果テーブルを開く
  async function searchClick() {
    if (autocompleteAdditive.length >= 1) {
      setErrorAdditive("");
    } else {
      return setErrorAdditive(constantsMsg.STR_PLZ_SELECT_ADDITIVE_NAME);
    }

    // navigate(foodAdditiveSearchResultPath, { state: { searchCondition: getSearchCondition() } });
    // const testwork = getSearchCondition();
    // dispatch(setSearchCondition(testwork));
    //navigate(foodAdditiveSearchResultPath);

    let reciveValue = await getSearchCondition();
    createAdditiveData(reciveValue);
  }


  // 検索条件を取得
  async function getSearchCondition() {
    try {
      // グローバルIP取得 2024/01/23 modify
      // let ip;
      // try {
      //   axios.get("https://ipinfo.io").then(res => ip = res.data.ip);
      // } catch {
      //   ip = null;
      // }
      body.ipAddr = await fetchIpAddress();
      
      // 検索履歴作成
      // if (ip) {
      //   body.ipAddr = ip;
      // }

      body.pageName = "EU食品添加物";


      // Eナンバー（添加物）を取得
      let foodAdditive = document.getElementsByName("food_additive");
      let additiveNameArray = foodAdditive[0].innerText.split(/\n/);
      let eNumberChecked = [];
      const kensakuList = [];
      for (let i = 0; i < additiveNameArray.length; i++) {
        for (let j = 0; j < additiveList.length; j++) {
          if (additiveNameArray[i] == additiveList[j].additive_name_jp) {
            eNumberChecked.push(additiveList[j].e_number);
            kensakuList.push({ product_code: additiveList[j].e_number, product_name: additiveList[j].additive_name_jp });
          }
        }
      }

      // 添加物履歴保存
      let arrStr = JSON.stringify(kensakuList);
      body.arrStr = arrStr;
      await axios.post("/t_search_his/insert_additive", body);

      // 食品カテゴリーナンバーを取得
      let foodCategoryNumber = null;
      let foodCategoryName = null;
      if (quaternaryCategoryName != constantsCategory.STR_QUATERNARY) {
        for (let i = 0; i < quaternaryCategoryList.length; i++) {
          if (quaternaryCategoryList[i].content == quaternaryCategoryName) {
            foodCategoryNumber = quaternaryCategoryList[i].food_category_number;
            foodCategoryName = quaternaryCategoryName;
          }
        }
      } else if (tertiaryCategoryName != constantsCategory.STR_TERTIARY) {
        for (let i = 0; i < tertiaryCategoryList.length; i++) {
          if (tertiaryCategoryList[i].content == tertiaryCategoryName) {
            foodCategoryNumber = tertiaryCategoryList[i].food_category_number;
            foodCategoryName = tertiaryCategoryName;
          }
        }
      } else if (secondaryCategoryName != constantsCategory.STR_SECONDARY) {
        for (let i = 0; i < secondaryCategoryList.length; i++) {
          if (secondaryCategoryList[i].content == secondaryCategoryName) {
            foodCategoryNumber = secondaryCategoryList[i].food_category_number;
            foodCategoryName = secondaryCategoryName;
          }
        }
      } else if (primaryCategoryName != constantsCategory.STR_PRIMARY) {
        for (let i = 0; i < primaryCategoryList.length; i++) {
          if (primaryCategoryList[i].content == primaryCategoryName) {
            foodCategoryNumber = primaryCategoryList[i].food_category_number;
            foodCategoryName = primaryCategoryName;
          }
        }
      }

      if (foodCategoryNumber != null) {
        // 食品カテゴリー履歴保存
        body.code = foodCategoryNumber;
        body.name = foodCategoryName;
        await axios.post("/t_search_his/insert_category", body);
      }


      const newArr = Array.from(new Set(eNumberChecked));  // 重複があった場合消す
      const enumber = newArr.join(',');  // 配列からコンマ区切りの文字列にする
      const searchCondition = { Enumber: enumber, foodCategoryNumber: foodCategoryNumber || '' }
      return searchCondition;

    } catch (err) {
      return setMsg(constantsMsg.STR_ERROR);
    }
  }

  // よく見られる添加物のOpen/Close
  function AdditiveClick() {
    if (isAdditiveOpen) {
      setIsAdditiveOpen(false);
    } else {
      setIsAdditiveOpen(true);
    }
  }

  // よく見られる食品カテゴリーのOpen/Close
  function CategoryClick() {
    if (isCategoryOpen) {
      setIsCategoryOpen(false);
    } else {
      setIsCategoryOpen(true);
    }
  }

  function additiveClickOpen() {
    setAdditiveOpen(true);
  }

  function additiveCancelButton() {
    setAdditiveOpen(false);
  }

  function categoryClickOpen() {
    setCategoryOpen(true);
  }

  function categoryCancelButton() {
    setCategoryOpen(false);
  }

  function ENumClickOpen() {
    setENumOpen(true);
  }

  function ENumCancelButton() {
    setENumOpen(false);
  }


  /*
    添加物情報を取得・テーブルにセット
  */
  async function createAdditiveData(reciveValue) {
    try {

      // Loading表示
      setIsLoading(true);

      let res;

      // 添加物リストを取得
      res = await axios.post("/m_eu_additive_list/select", body);
      const additiveList = res.data.dataList;
      setAdditiveList(additiveList);

      // 食品カテゴリーリストを取得
      res = await axios.post("/m_eu_food_category_list/select", body);
      const foodCategoryList = res.data.dataList;
      setFoodCategoryList(foodCategoryList);

      // 脚注リストを取得
      res = await axios.post("/m_eu_footnote/select", body);
      const footnoteList = res.data.dataList;
      setFootnoteList(footnoteList);

      // 選択されたEナンバーと食品カテゴリーに紐付く添加物情報を取得
      body.enumber = reciveValue.Enumber;
      body.foodCategoryNumber = reciveValue.foodCategoryNumber;
      res = await axios.post("/m_eu_food_additive_db/select", body);
      const foodAdditiveDBList = res.data.dataList;
      setfoodAdditiveDBList(foodAdditiveDBList);

      // グループの脚注「リスト」を取得
      let groupFootnoteList = [];
      groupFootnoteList = getGroupFootnoteList(additiveList);

      // 添加物テーブルを作成
      let additiveRowsData = [];
      var additiveInfoArray = [];
      var enumber = ""
      var foodCategoryNumber = ""
      var foodCategory = "";
      var footNote = "";
      var groupFootnote = "";

      for (let i in foodAdditiveDBList) {
        // 初期化
        foodCategory = "";
        footNote = "";

        enumber = foodAdditiveDBList[i].e_number || ''
        foodCategoryNumber = foodAdditiveDBList[i].food_category_number || ''

        // 食品カテゴリーを取得
        foodCategory = getFoodCategoryName(foodCategoryList, foodCategoryNumber);

        // 脚注を取得
        footNote = getFootnote(footnoteList, foodAdditiveDBList[i].footnote_number) || ''
        footNote = getAdditiveFootnote(footNote, additiveList, enumber)

        // グループの脚注を取得
        groupFootnote = getGroupFootnote(groupFootnoteList, foodAdditiveDBList[i].group)

        // 添加物名_EN、添加物名_JP、国の規制を取得
        additiveInfoArray = getAdditiveInfoArray(additiveList, enumber);

        additiveRowsData.push({
          id: i
          , enumber: enumber
          , foodCategory: foodCategory
          , foodCategoryNumber: foodCategoryNumber
          , INSnumber: foodAdditiveDBList[i].ins_number || ''
          , additiveNameEN: additiveInfoArray[0].additive_name_en || ''
          , additiveNameJP: additiveInfoArray[0].additive_name_jp || ''
          , nationalRegulations: additiveInfoArray[0].national_regulations || ''
          , maximumValue: foodAdditiveDBList[i].maximum_value || ''
          , footnote: footNote || ''
          , groupFootnote: groupFootnote || ''
          , constraintException: foodAdditiveDBList[i].constraint_exception || ''
          , group: foodAdditiveDBList[i].group || ''
        });
      };

      // 値をセット
      setResultFoodAdditive(additiveRowsData);

      // 検索結果なし
      if (additiveRowsData.length == 0) {
        setHiddenTable(true);
        setSearchFailed(true);
      }
      // 初期表示
      else if (additiveRowsData[0].enumber == null) {
        setHiddenTable(true);
        setSearchFailed(true);
      }
      // 検索結果あり
      else {
        setHiddenTable(false);
        setSearchFailed(false);
      }

    } catch (err) {
      console.error(err);
      return setMsg(constantsMsg.STR_ERROR);
    } finally {
      setIsLoading(false);
    }
  }

  /*
    Eナンバーから添加物名_EN、添加物名_JP、国の規制を取得
  */
  function getAdditiveInfoArray(additiveList, enumber) {
    var additiveInfoArray = [];

    // m_eu_additive_listの配列でループする
    additiveList.forEach((additiveListInfo) => {

      if (additiveListInfo.e_number == enumber) {
        // リストに代入
        additiveInfoArray.push({
          additive_name_en: additiveListInfo.additive_name_en || ''
          , additive_name_jp: additiveListInfo.additive_name_jp || ''
          , national_regulations: additiveListInfo.national_regulations || ''
        });

        return additiveInfoArray
      };
    });

    return additiveInfoArray
  }

  /*
    脚注を取得
  */
  function getFootnote(footnoteList, footnote) {
    const strAt = "@";

    // 空、もしくは、"@"がなければreturn
    if (footnote == undefined || footnote.indexOf(strAt) == -1) {
      return footnote
    };

    // 脚注番号（"@"付き）を抽出
    // const patternNum = /(@[^@]+@)+/g;
    // let matchFootnoteArr = footnoteNo.match(patternNum);

    // 脚注番号を取り出すために"@"で切り分ける
    let matchFootnoteArr = footnote.split(strAt);

    // null回避
    if (matchFootnoteArr.length == 0) {
      return footnote
    }

    // 切り分けた脚注番号でループ
    for (let i in matchFootnoteArr) {

      // 脚注を検索
      for (let j in footnoteList) {
        if (footnoteList[j].footnote_number == matchFootnoteArr[i]) {
          // 脚注番号と脚注内容を置き換える
          footnote = footnote.replace(strAt + matchFootnoteArr[i] + strAt, footnoteList[j].footnote);
          break;
        };
      };
    }

    return footnote;
  };

  /*
    添加物一覧内の脚注を取得
  */
  function getAdditiveFootnote(footnote, additiveList, enumber) {
    const strLink = "@link@"

    // 添加物一覧内の脚注を検索
    for (let i in additiveList) {
      if (additiveList[i].e_number == enumber) {
        // 脚注が空でない場合
        if (additiveList[i].remarks) {
          // 脚注を追加する
          if (footnote.indexOf(strLink) == -1) {
            footnote = footnote + '\n' + additiveList[i].remarks
          }
          else {
            footnote = footnote.replace(strLink, additiveList[i].remarks + '\n' + strLink)
          };
          break;
        };
      };
    };

    return footnote
  }

  /*
    グループの脚注を取得
  */
  function getGroupFootnote(groupFootnoteList, group) {
    const strDollar = "$";
    const strAt = "@";

    var resultGroupFootnote = ""

    // 空の場合、"$"がない場合、0の場合はreturn
    if (group == undefined || group.indexOf(strDollar) == -1 || group == 0) {
      return resultGroupFootnote
    };

    // グループ番号（"$"付き）を抽出
    const patternDollar = /(\$[^\$]+\$)+/g;
    let matchDollarArr = group.match(patternDollar);

    // null回避
    if (matchDollarArr.length == 0) {
      return resultGroupFootnote = "-"
    }

    // グループ名を置き換える
    var groupName = ""
    groupName = matchDollarArr[0].replace(strDollar, "");
    groupName = groupName.replace(strDollar, "");
    resultGroupFootnote = group.replace(matchDollarArr[0], "(グループ" + groupName + ")");

    // "@"がなければreturn
    if (group.indexOf(strAt) == -1) {
      return resultGroupFootnote
    };

    // 脚注番号（"@"付き）を抽出
    const patternAt = /(@[^@]+@)+/g;
    let matchAtArr = group.match(patternAt);

    // null回避
    if (matchAtArr.length == 0) {
      return resultGroupFootnote
    };

    var splitArr = [];

    // 置き換え
    for (let i in matchAtArr) {
      splitArr = matchAtArr[i].split(strAt);
      for (let j in splitArr) {
        for (let k in groupFootnoteList) {
          if (groupFootnoteList[k].footnoteNo == splitArr[j]) {
            resultGroupFootnote = resultGroupFootnote.replace(strAt + splitArr[j] + strAt, '\n' + groupFootnoteList[k].footnote);
          }
        }
      }
    }

    return resultGroupFootnote;
  };

  /*
    グループの脚注「リスト」を取得
  */
  function getGroupFootnoteList(additiveList) {

    const strDollar = "$";
    var matchDollarArr = [];
    let groupFootnoteList = [];
    var footnoteNo = "";

    additiveList.forEach((additiveData) => {
      // 空、もしくは、"$"がなければ何もしない
      if (additiveData.group_footnote == undefined || additiveData.group_footnote.indexOf(strDollar) == -1) {
        ;
      }
      else {
        // グループ番号（"$"付き）を抽出して"$"を消す
        const patternDollar = /(\$[^\$]+\$)+/g;
        matchDollarArr = additiveData.group_footnote.match(patternDollar);
        footnoteNo = matchDollarArr[0].replace(strDollar, "");
        footnoteNo = footnoteNo.replace(strDollar, "");

        // リストに入れる
        groupFootnoteList.push({
          footnoteNo: footnoteNo || ''
          , footnote: additiveData.group_footnote.replace(matchDollarArr[0], "") || ''
        });
      };
    });

    return groupFootnoteList
  }

  /*
    食品カテゴリー名を取得
  */
  function getFoodCategoryName(foodCategoryList, foodCategoryNumber) {
    var foodCategory = ""
    foodCategoryList.forEach((foodCategoryListInfo) => {
      // 食品カテゴリーナンバーが一致した場合は名前を代入
      if (foodCategoryListInfo.food_category_number == foodCategoryNumber) {
        foodCategory = foodCategoryListInfo.content
        return foodCategory
      };
    });
    return foodCategory
  }

  /*
    改行コードを改行タグに変換
  */
  function brTagConvart(text) {
    return text.split('\n').map(t => (<>{t}<br /></>))
  }

  // ヘッダー
  const columns = [
    { field: 'e_number', headerName: 'E番号', width: 100 },
    { field: 'additive_name_jp', headerName: '添加物名', width: 500 },
  ];

  return (
    <>
      <Helmet
        title={constantsMet.title}
        // タイトル、metaデータ
        meta={[
          { name: 'description', content: constantsMet.description },
          { property: 'keywords', content: constantsMet.keywords },

          { property: 'og:title', content: constantsMet.og_title },
          { property: 'og:description', content: constantsMet.og_description },
          { property: 'og:image', content: { img_ogp_images } },

          { property: 'og:url', content: constantsMet.og_url },
          { property: 'og:site_name', content: constantsMet.og_site_name },
        ]}
      />

      <MenuMenu sel={3} />
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            {/* Loading */}
            <Backdrop open={isLoading}
              sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
              <CircularProgress />
            </Backdrop>
            <div class="selectSearchArea">

              {constantsElement.TXT_01}

              <div class="selectSearchArea">
                <dl>
                  <dt>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span>添加物</span>
                      <span class="hissu" style={{ marginRight: "20px" }}>必須</span>

                      {/* <a href="#"><span class="icon"> */}

                      <a onClick={additiveClickOpen} style={{ cursor: "pointer" }}>
                        <span class="icon" >
                          <img src={icon_hatena} alt="" />
                        </span>添加物について
                      </a>

                      <a onClick={ENumClickOpen} style={{ cursor: "pointer", marginLeft: "15px" }}>E番号一覧</a>
                    </div>
                  </dt>
                  <dd>
                    <div class="button" style={{ margin: "0 0 10px" }}>
                      <input type="button" class="buttonDefault" onClick={handleClickOpen} value="一覧から選択" />
                    </div>
                    <div class="text">
                      <Autocomplete
                        id="food_additive"
                        name="food_additive"
                        className="d001_text"
                        value={autocompleteAdditive}
                        multiple // 複数選択
                        freeSolo // 開閉をなくす
                        options={additiveOptions}
                        onInputChange={(e, changeValue) => {
                          additiveSearchHandler(changeValue);
                        }} // テキスト内容変更時
                        onChange={additiveChange} // 選択状態変更時
                        renderTags={(tagValue, getTagProps) =>
                          tagValue.map((option, index) => (
                            <Chip
                              label={label(option)}
                              {...getTagProps({ index })}
                            />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={Boolean(errorAdditive == "" ? false : true)}
                            // Enter無効
                            inputProps={{
                              ...params.inputProps,
                              onKeyDown: (e) => {
                                if (e.key === 'Enter') {
                                  e.stopPropagation();
                                }
                              },
                            }}
                          />
                        )}
                        filterOptions={(options) => options}  // オートコンプリートの検索処理をなくす
                        getOptionLabel={(option) => label(option)}
                      />
                    </div>
                    {/* <br /> */}
                    <FormControl error={errorAdditive}>
                      <FormHelperText>{errorAdditive}</FormHelperText>
                    </FormControl>

                  </dd>
                </dl>
              </div>

              <div class="selectArea">
                <dl class="selectCol4">
                  <dt>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span>食品カテゴリー</span>
                      {/* <a href="#"><span class="icon"> */}
                      <a onClick={categoryClickOpen} style={{ cursor: "pointer", marginLeft: "20px" }}><span class="icon">
                        <img src={icon_hatena} alt="" />
                      </span>食品カテゴリーについて</a>
                    </div>
                  </dt>
                  <dd>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} width="100%">
                      <TextField id="primary_category" variant="outlined"
                        className="d001_text"
                        style={{ width: "100%" }}
                        value={primaryCategoryName}
                        required
                        select
                        onChange={e => {
                          primaryCategorySelect(e.target.value);
                        }}
                      >
                        {primaryCategoryList.map((option) => (
                          <MenuItem
                            key={option.food_category_number}
                            value={option.content}>
                            {option.content}
                          </MenuItem>
                        ))}
                      </TextField>

                      <TextField id="secondary_category" variant="outlined"
                        className="d001_text"
                        style={{ width: "100%" }}
                        value={secondaryCategoryName}
                        required
                        select
                        onChange={e => {
                          secondaryCategorySelect(e.target.value);
                        }}
                      >
                        {secondaryCategoryList.map((option) => (
                          <MenuItem
                            key={option.food_category_number}
                            value={option.content}>
                            {option.content}
                          </MenuItem>
                        ))}
                      </TextField>

                      <TextField id="tertiary_category" variant="outlined"
                        className="d001_text"
                        style={{ width: "100%" }}
                        value={tertiaryCategoryName}
                        required
                        select
                        onChange={e => {
                          tertiaryCategorySelect(e.target.value);
                        }}
                      >
                        {tertiaryCategoryList.map((option) => (
                          <MenuItem
                            key={option.food_category_number}
                            value={option.content}>
                            {option.content}
                          </MenuItem>
                        ))}
                      </TextField>

                      <TextField id="quaternary_category" variant="outlined"
                        className="d001_text"
                        style={{ width: "100%" }}
                        value={quaternaryCategoryName}
                        required
                        select
                        onChange={e => {
                          quaternaryCategorySelect(e.target.value);
                        }}
                      >
                        {quaternaryCategoryList.map((option) => (
                          <MenuItem
                            key={option.food_category_number}
                            value={option.content}>
                            {option.content}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Stack>
                  </dd>
                </dl>
              </div>

              <div class="checkResultWrap">
                <div class="checkDetailBtn">
                  <a onClick={searchClick}>チェック</a>
                </div>
              </div>

              {isHiddenTable ? <></>
                :
                <div style={{ width: "100%", marginTop: "10px" }}>
                  <FoodAdditiveSearchResultTable searchResultData={resultFoodAdditive} />
                </div>
              }

              {isSearchFailed ?
                <div style={{ backgroundColor: "#EDEEF2", textAlign: "center", padding: "50px", marginTop: "30px", marginBottom: "30px" }}>
                  <span>{constantsMsg.STR_RESULT_NOTFOUND}</span>
                </div>
                :
                <></>
              }

              <div className="dialog">
                <Dialog
                  fullWidth
                  maxWidth="md"
                  height="md"
                  fullScreen={fullScreen}
                  open={open}
                  onClose={cancelButton}
                  aria-labelledby="responsive-dialog-title"
                >
                  <BootstrapDialogTitle id="customized-dialog-title" style={{ backgroundColor: "#1B335E", color: "#fff", textAlign: "center" }} onClose={cancelButton}>
                    添加物名一覧
                  </BootstrapDialogTitle>
                  <ToggleButtonGroup
                    color="primary"
                    value={dialogCategory}
                    exclusive
                    onChange={categoryChange}
                    aria-label="Platform"
                    fullWidth
                  >
                    <ToggleButton value="1">{colorName}</ToggleButton>
                    <ToggleButton value="2">{sweetName}</ToggleButton>
                    <ToggleButton value="3">{otherName}</ToggleButton>
                  </ToggleButtonGroup>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    {isColorDialog ?
                      <Tabs
                        value={colorDialogValue}
                        onChange={colorDialogChange}
                        aria-label="basic tabs example"
                        variant="scrollable"
                        scrollButtons
                        allowScrollButtonsMobile
                      >
                        {initialsTab}
                      </Tabs>
                      : null}
                    {isSweetDialog ?
                      <Tabs
                        value={sweetDialogValue}
                        onChange={sweetDialogChange}
                        aria-label="basic tabs example"
                        variant="scrollable"
                        scrollButtons
                        allowScrollButtonsMobile
                      >
                        {initialsTab}
                      </Tabs>
                      : null}
                    {isOtherDialog ?
                      <Tabs
                        value={otherDialogValue}
                        onChange={otherDialogChange}
                        aria-label="basic tabs example"
                        variant="scrollable"
                        scrollButtons
                        allowScrollButtonsMobile
                      >
                        {initialsTab}
                      </Tabs>
                      : null}
                  </Box>
                  <DialogContent id="dialog-content">
                    <TabPanel value={0} index={0}>
                      <div hidden={!isColorDialog}>{additiveColorDialogContent}</div>
                      <div hidden={!isSweetDialog}>{additiveSweetDialogContent}</div>
                      <div hidden={!isOtherDialog}>{additiveOtherDialogContent}</div>
                    </TabPanel>
                  </DialogContent>
                  <div style={{
                    display: "flex"
                    , justifyContent: "center"
                    , position: "relative"
                    , flexWrap: "wrap"
                    , marginTop: "40px"
                    , marginBottom: "40px"
                  }}>
                    <input type="button" style={{ width: "150px", margin: "0 10px" }} value="キャンセル" class="buttonDefault modalClose graylBtn" onClick={cancelButton} />
                    <input type="button" style={{ width: "150px", margin: "0 10px" }} value="決定" class="buttonDefault" onClick={decisionButton} />
                  </div>
                </Dialog>
              </div>

              <div className="dialog">
                <Dialog
                  fullWidth
                  maxWidth="md"
                  height="md"
                  fullScreen={fullScreen}
                  open={additiveOpen}
                  onClose={additiveCancelButton}
                  aria-labelledby="responsive-dialog-title"
                >
                  {constantsElement.TXT_02}
                  <input type="button" style={{ display: "block", width: "150px", margin: "auto", marginBottom: "15px", marginTop: "-5px" }} value="閉じる" class="buttonDefault modalClose graylBtn" onClick={additiveCancelButton} />
                </Dialog>
              </div>

              <div className="dialog">
                <Dialog
                  fullWidth
                  maxWidth="md"
                  height="md"
                  fullScreen={fullScreen}
                  open={categoryOpen}
                  onClose={categoryCancelButton}
                  aria-labelledby="responsive-dialog-title"
                >
                  {constantsElement.TXT_03}
                  <input type="button" style={{ display: "block", width: "150px", margin: "auto", marginBottom: "15px", marginTop: "-5px" }} value="閉じる" class="buttonDefault modalClose graylBtn" onClick={categoryCancelButton} />
                </Dialog>
              </div>

              <div className="dialog">
                <Dialog
                  fullWidth
                  maxWidth="md"
                  height="md"
                  fullScreen={fullScreen}
                  open={ENumOpen}
                  onClose={ENumCancelButton}
                  aria-labelledby="responsive-dialog-title"
                >
                  <BootstrapDialogTitle id="customized-dialog-title" style={{ backgroundColor: "#1B335E", color: "#fff", textAlign: "center" }} onClose={cancelButton}>
                    E番号一覧
                  </BootstrapDialogTitle>
                  <DialogContent id="dialog-content">
                    <div style={{ width: '100%' }}>
                      <DataGrid
                        className='DataGrid'
                        columns={columns}
                        rows={rows}
                        autoHeight
                        disableSelectionOnClick
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        pagination
                        localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                      />
                    </div>
                  </DialogContent>
                  <input type="button" style={{ display: "block", width: "150px", margin: "auto", marginBottom: "15px", marginTop: "15px" }} value="閉じる" class="buttonDefault modalClose graylBtn" onClick={ENumCancelButton} />
                </Dialog>
              </div>
            </div>
          </div>

          <div class="popularItemWrap">
            <div class="popularItem">
              <p class="h2En">ADDITIVE</p>
              <h2>よく見られている添加物</h2>
              <div class="popularItemList">
                <ul>
                  {seenAdditiveList}
                </ul>
                <div style={isAdditiveOpen ? { display: "block" } : { display: "none" }}>
                  <ul>
                    {hideAdditiveList}
                  </ul>
                </div>
                <span class={isAdditiveOpen ? "openTrigger isOpen" : "openTrigger"} onClick={() => AdditiveClick()}></span>
              </div>
            </div>
            <div class="popularItem">
              <p class="h2En">FOOD CATEGORY </p>
              <h2>よく見られている食品カテゴリー</h2>
              <div class="popularItemList">
                <ul>
                  {seenCategoryList}
                </ul>
                <div style={isCategoryOpen ? { display: "block" } : { display: "none" }}>
                  <ul>
                    {hideCategoryList}
                  </ul>
                </div>
                <span class={isCategoryOpen ? "openTrigger isOpen" : "openTrigger"} onClick={() => CategoryClick()}></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default D0131FoodAdditive;

// styledComponents
const CtableHeader = styled(TableCell)(() => ({
  backgroundColor: "#EDEEF2",
  textAlign: 'center',
  fontSize: '12px',
  border: `1px solid #C7C7C7`,
  width: `60px`,
}));

const CtableCell = styled(TableCell)(() => ({
  border: `1px solid #C7C7C7`,
}));